export const WHATSAPP_CATEGORY_OPTIONS = [
  { id: 'MARKETING', name: 'Marketing' },
  { id: 'UTILITY', name: 'Utility' },
  { id: 'AUTHENTICATION', name: 'Authentication' },
];

export const LANGUAGE_OPTIONS = [
  { id: 'en_US', name: 'English' },
  { id: 'ar', name: 'Arabic' },
];

export const HEADER_OPTIONS = [
  { id: 'NONE', title: 'None' },
  { id: 'TEXT', title: 'Text' },
  { id: 'IMAGE', title: 'Image' },
  { id: 'VIDEO', title: 'Video' },
  { id: 'DOCUMENT', title: 'Document' },
  { id: 'LOCATION', title: 'Location' },
];

export const BUTTONS_INFO_LIST = {
  QUICK_REPLY: {
    type: 'QUICK_REPLY',
    icon: 'i-lucide-reply',
    name: 'Quick Reply',
  },
  URL: { type: 'URL', icon: 'i-lucide-link', name: 'Visit Website' },
  PHONE_NUMBER: {
    type: 'PHONE_NUMBER',
    icon: 'i-lucide-phone-call',
    name: 'Call Phone',
  },
  COPY_CODE: { type: 'COPY_CODE', icon: 'i-lucide-copy', name: 'Copy Code' },
  VOICE_CALL: {
    type: 'VOICE_CALL',
    icon: 'i-lucide-phone',
    name: 'Voice Call',
  },
};

export const MEDIA_CONFIG = {
  IMAGE: {
    accept: 'image/png, image/jpeg, image/jpg',
    types: ['image/jpeg', 'image/jpg', 'image/png'],
    maxSize: 5 * 1024 * 1024,
    maxSizeLabel: '5MB',
    icon: '🖼️',
  },
  VIDEO: {
    accept: 'video/mp4, video/3gpp, video/3gp',
    types: ['video/mp4', 'video/3gpp', 'video/3gp'],
    maxSize: 16 * 1024 * 1024,
    maxSizeLabel: '16MB',
    icon: '🎥',
  },
  DOCUMENT: {
    accept: 'application/pdf',
    types: ['application/pdf'],
    maxSize: 100 * 1024 * 1024,
    maxSizeLabel: '100MB',
    icon: '📄',
  },
};

export const VALIDATION_CONSTANTS = {
  MAX_TEMPLATE_NAME_LENGTH: 512,
  MAX_TOTAL_BUTTONS: 10,
  MAX_QUICK_REPLY_BUTTONS: 10,
  MAX_URL_BUTTONS: 2,
  MAX_PHONE_BUTTONS: 1,
  MAX_COPY_CODE_BUTTONS: 1,
  MAX_VOICE_CALL_BUTTONS: 1,
  MAX_BUTTON_TEXT: 25,
  MAX_HEADER_TEXT: 60,
  MAX_BODY_TEXT: 1024,
  MAX_FOOTER_TEXT: 60,
  MAX_CARD_BODY_TEXT: 160,
  MAX_BODY_VARIABLES: 25,
  MAX_HEADER_VARIABLES: 1,
  MAX_URL_LENGTH: 2000,
  MAX_PHONE_LENGTH: 20,
  MAX_CAROUSEL_CARDS: 10,
  MIN_CAROUSEL_CARDS: 2,
  DYNAMIC_VARIABLE_PATTERN: /\{\{1\}\}$/,
  ONLY_ONE_VARIABLE: /\{\{1\}\}/g,
  PHONE_REGEX: /^\+\d{7,20}$/,
  TEMPLATE_NAME_PATTERN: /^[a-z0-9_]+$/,
  VARIABLE_PATTERN: /\{\{\d+\}\}/g,
};

export const AUTH_TEMPLATE_STRINGS = {
  en_US: {
    BASE_CONTENT: '{{1}} is your verification code.',
    SECURITY_RECOMMENDATION: 'For your security, do not share this code.',
    EXPIRATION_TEXT: 'Expires in {minutes} minutes.',
  },
  ar: {
    BASE_CONTENT: '{{1}} هو كود التحقق الخاص بك.',
    SECURITY_RECOMMENDATION: 'للحفاظ على أمانك، لا تشارك هذا الكود مع أي شخص.',
    EXPIRATION_TEXT: 'تنتهي صلاحيتها خلال {minutes} دقائق.',
  },
};
